import {
  captureGridHistoryState,
  getGridHistoryScene,
  gridHistorySnapshotsEqual,
} from './gridHistory';
import {
  clearPendingGridHistoryBefore,
  getGridHistoryCommitTimer,
  getPendingGridHistoryBefore,
  isPendingGridHistorySessionCurrent,
  setGridHistoryCommitTimer,
} from './gridHistoryCommit';
import { getLastCommittedGridHistory } from './gridHistoryBaseline';
import { isGridHistoryReady, isGridHistorySuppressed } from './gridHistorySuppress';

function resolveCommitBeforeSnapshot() {
  return getPendingGridHistoryBefore() || getLastCommittedGridHistory();
}

/**
 * Commit any in-flight debounced edit before recording a new discrete step.
 * Keeps undo/redo chain intact: step N's "after" becomes step N+1's "before".
 */
export function flushPendingGridHistoryCommit(recordTransition, label = 'edit') {
  const existingTimer = getGridHistoryCommitTimer();
  if (existingTimer) {
    clearTimeout(existingTimer);
    setGridHistoryCommitTimer(null);
  }

  if (!getPendingGridHistoryBefore()) {
    return false;
  }

  if (!isPendingGridHistorySessionCurrent()) {
    clearPendingGridHistoryBefore();
    return false;
  }

  if (!isGridHistoryReady() || isGridHistorySuppressed()) {
    clearPendingGridHistoryBefore();
    return false;
  }

  const scene = getGridHistoryScene();
  const before = resolveCommitBeforeSnapshot();
  if (!before || !scene || typeof recordTransition !== 'function') {
    clearPendingGridHistoryBefore();
    return false;
  }

  const after = captureGridHistoryState(scene);
  if (!gridHistorySnapshotsEqual(before, after)) {
    recordTransition(before, scene, label);
  }
  clearPendingGridHistoryBefore();
  return true;
}
